import styled from 'styled-components';
import React from 'react';
import {colSetup} from '../../../ui-toolkit/grid/grid-features/col/ColContainer';
import {Col} from '../../../ui-toolkit/grid/grid-features/col/Col';

export const TitleLabel = styled.h2`
    color: var(--title-text-100);
    font-size: var(--text-size-large);
    margin-bottom: 8px;
    font-weight: 800;
`;

const ColWidthSetup = (fullWidth) => {
    if (fullWidth === true)
        return `
        ${colSetup({width: `100% !important`})};
    `;
    else return ``;
};

const DetailCategoryWrapper = styled(Col.Wrapper)`
    ${colSetup({width: `33.33%`})};

    @media only screen and (max-width: 2000px) {
        ${colSetup({width: `50%`})};
    }
    @media only screen and (max-width: 1240px) {
        ${colSetup({width: `100%`})};
    }

    display: block;
    --row-spacer: 0.75rem;
    margin-bottom: 32px;
    ${({fullWidth}) => ColWidthSetup(fullWidth)};
`;

const DetailCategory = ({children, title, fullWidth}) => (
    <DetailCategoryWrapper fullWidth={fullWidth}>
        {title && <TitleLabel>{title}</TitleLabel>}
        {children}
    </DetailCategoryWrapper>
);

DetailCategory.Wrapper = DetailCategoryWrapper;
export default DetailCategory;
export {DetailCategoryWrapper};
